import { render, staticRenderFns } from "./FlagButton.vue?vue&type=template&id=71bb7cd6&scoped=true"
import script from "./FlagButton.vue?vue&type=script&lang=js"
export * from "./FlagButton.vue?vue&type=script&lang=js"
import style0 from "./FlagButton.vue?vue&type=style&index=0&id=71bb7cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb7cd6",
  null
  
)

export default component.exports